import { Modal } from "antd";
import ClientNotes from "./ClientNotes";

const ClientNotesModal = ({ clientId, onClose, canAdd = true }) => (
  <Modal
    className="smtv-modal"
    visible={null != clientId}
    title="Notes du client"
    footer={null}
    forceRender
    onCancel={onClose}
  >
    {null != clientId && (
      <ClientNotes clientId={clientId} canAdd={false} variant="panel" />
    )}
  </Modal>
);

export default ClientNotesModal;
